"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.MODAL_THEMES_CLASSNAME = exports.MODAL_THEMES = exports.MODAL_SIZES_CLASSNAME = exports.MODAL_SIZES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _MODAL_SIZES_CLASSNAM, _MODAL_THEMES_CLASSNA;

var MODAL_SIZES = {
  LG: 'lg',
  MD: 'md',
  SM: 'sm',
  XL: 'xl',
  XS: 'xs'
};
exports.MODAL_SIZES = MODAL_SIZES;
var MODAL_SIZES_CLASSNAME = (_MODAL_SIZES_CLASSNAM = {}, (0, _defineProperty2["default"])(_MODAL_SIZES_CLASSNAM, MODAL_SIZES.LG, 'pp-modals-lg'), (0, _defineProperty2["default"])(_MODAL_SIZES_CLASSNAM, MODAL_SIZES.MD, 'pp-modals-md'), (0, _defineProperty2["default"])(_MODAL_SIZES_CLASSNAM, MODAL_SIZES.SM, 'pp-modals-sm'), (0, _defineProperty2["default"])(_MODAL_SIZES_CLASSNAM, MODAL_SIZES.XL, 'pp-modals-xl'), (0, _defineProperty2["default"])(_MODAL_SIZES_CLASSNAM, MODAL_SIZES.XS, 'pp-modals-xs'), _MODAL_SIZES_CLASSNAM);
exports.MODAL_SIZES_CLASSNAME = MODAL_SIZES_CLASSNAME;
var MODAL_THEMES = {
  LIGHT: 'light',
  DARK: 'dark'
};
exports.MODAL_THEMES = MODAL_THEMES;
var MODAL_THEMES_CLASSNAME = (_MODAL_THEMES_CLASSNA = {}, (0, _defineProperty2["default"])(_MODAL_THEMES_CLASSNA, MODAL_THEMES.LIGHT, 'pp-modals-theme-light'), (0, _defineProperty2["default"])(_MODAL_THEMES_CLASSNA, MODAL_THEMES.DARK, 'pp-modals-theme-dark'), _MODAL_THEMES_CLASSNA);
exports.MODAL_THEMES_CLASSNAME = MODAL_THEMES_CLASSNAME;